<ng-container>
  <form [formGroup]="form" (submit)="onSave()">
    <tj-partner-edit-form [partner]="partner" [form]="form"></tj-partner-edit-form>
    <button pButton type="submit" [loading]="isSaving" label="Save"></button>
  </form>
</ng-container>
